import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import HomeMap from '@/pages/HomeMap'
import MapDashboard from '@/pages/MapDashboard'
import Signup from '@/pages/Signup'
import Login from '@/pages/Login'
import LandingPage from '@/pages/LandingPage'
import ResetPassword from '@/pages/ResetPassword'
import OrderDetail from '@/pages/OrderDetail'
import Order from '@/pages/Order'
import Run from '@/pages/Run'
import CreateOrder from '@/pages/CreateOrder'
import UpdateOrder from '@/pages/UpdateOrder'
import AccountSettings from '@/pages/AccountSettings'
import DriverSettings from '@/pages/DriverSettings'
import EditDriver from '@/pages/EditDriver'
import CompanySettings from '@/pages/CompanySettings'
import Support from '@/pages/Support'
import Privacy from '@/pages/Privacy'
import Terms from '@/pages/Terms'
import {auth} from '../firebase'


Vue.mixin({


  computed: {


    /*
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

    isIPad() {
      if(/iPad/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    */


  },


})



Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/list',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true }
    },
    /*
    {
      path: '/map',
      name: 'HomeMap',
      component: HomeMap,
      meta: { requiresAuth: true }
    },
    */


    {
      path: '/map',
      name: 'MapDashboard',
      component: MapDashboard,
      meta: { requiresAuth: true }
    },


    /*
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    */

    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/order/:id',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/u/:company_id/o/:id',
      name: 'Order',
      component: Order
    },
    {
      path: '/r/:company_id',
      name: 'Run',
      component: Run
    },
    {
      path: '/create_order',
      name: 'CreateOrder',
      component: CreateOrder,
      meta: { requiresAuth: true }
    },
    {
      path: '/update_order/:id',
      name: 'UpdateOrder',
      component: UpdateOrder,
      meta: { requiresAuth: true }
    },
    {
      path: '/account_settings',
      name: 'AccountSettings',
      component: AccountSettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/driver_settings',
      name: 'DriverSettings',
      component: DriverSettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/edit_driver',
      name: 'EditDriver',
      component: EditDriver,
      meta: { requiresAuth: true }
    },
    {
      path: '/company_settings',
      name: 'CompanySettings',
      component: CompanySettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      meta: { requiresAuth: true }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
  ]
})


router.beforeEach((to, from, next) => {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let currentUser = auth.currentUser
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    console.log("check")
    auth.onAuthStateChanged(function (user) {
      if (user) {
        console.log("logged in")
        next()
      } else {
        console.log("not logged in yet")
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js